import { useCallback } from 'react';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { getMultiSelectionState } from '@components/MainStage/multiSelection.store';
import { canvasState } from '@components/MainStage/store';
import { useProject } from '@context/Project';
import useResetViewport from '@hooks/canvas/useResetViewport';

const usePanelClick = ({ closeMenu }: { closeMenu: () => void }) => {
  const { handleCloseDrawer, drawer } = useProject();
  const resetViewPort = useResetViewport();

  return useCallback(() => {
    if (getFocusOnState().sourceId) {
      getMultiSelectionState().clear();
      closeMenu();
      return;
    }

    document.dispatchEvent(new Event('mousedown'));

    getMultiSelectionState().clear();

    const { unselectActiveEdge, unselectActiveNode } = canvasState();

    unselectActiveEdge();
    unselectActiveNode();

    closeMenu();
    handleCloseDrawer();

    if (drawer) {
      resetViewPort();
    }
  }, [drawer, handleCloseDrawer, closeMenu]);
};

export default usePanelClick;
